import {TFocusableNodeType} from '../../../../Tree/Constants/FocusableNodeType';
import TContainerPropsMap from '../Types/TContainerPropsMap';

const isVirtualVerticalListProps = <T extends TFocusableNodeType>(
    type: T,
    _: TContainerPropsMap[TFocusableNodeType]
): _ is TContainerPropsMap['VIRTUAL_VERTICAL_LIST'] => type === 'VIRTUAL_VERTICAL_LIST';

export default isVirtualVerticalListProps;
